// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3X7hr","title":"Info_title__3fxmD","selects":"Info_selects__1LdSD","requiredAsterisk":"Info_requiredAsterisk__8R0Jq"};